export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/slowOverlay.worker.e68014f7.worker.js");
}
